// eslint-disable-next-line @typescript-eslint/no-var-requires
const linkify = require('linkify-it')();

type Links = {
    raw: string;
    url: string;
    lastIndex: number;
    index: number;
};

export const textOutput = (text: string | null) => {
  const links = linkify.match(text) as Links[];
  if (links) {
    return text?.split(' ').reduce((fullString, value) => {
      const linksItem = links.find((link) => value.includes(link.raw));
      // exact link value within value, without . ! ? 
      const exactLink = linksItem && value.slice(0, linksItem.lastIndex - linksItem.index);
      // rest of the characters within value like . ! ? 
      const restOfTheLink = (exactLink && value !== exactLink) ? value.slice(exactLink?.length - value.length) : '';

      const linkText = linksItem && `[${exactLink}](${linksItem.url})${restOfTheLink}`;

      return `${fullString} ${linkText || value}`.trim();
    }, '');
  } else {
    return text;
  }
};